import BasketService from '@/services/v1/BasketService';
import UserService from '@/services/v1/UserService';
import LocationService from '@/services/v1/LocationService';
import RecommendationService from '@/services/v1/RecommendationService';
import CheckoutService from '@/services/v1/CheckoutService';
import PartnerService from '@/services/v1/PartnerService';
import CashbackService from '@/services/v1/CashbackService';
import config from '@/plugins/config';
import CustomersService from '@/services/v1/CustomersService';
import MnogoRuService from '@/services/v1/MnogoRuService';

export default () => {
  const clonedConfig = { ...config };

  const basket = new BasketService(clonedConfig);
  const user = new UserService(clonedConfig);
  const location = new LocationService(clonedConfig);
  const recommendation = new RecommendationService(clonedConfig);
  const checkout = new CheckoutService(clonedConfig);
  const partner = new PartnerService(clonedConfig);
  const cashback = new CashbackService(clonedConfig);
  const customers = new CustomersService(clonedConfig);
  const mnogoRu = new MnogoRuService(clonedConfig);

  return {
    basket,
    user,
    location,
    recommendation,
    checkout,
    partner,
    cashback,
    customers,
    mnogoRu,
  };
};
